module.exports = __webpack_public_path__ + "static/media/2.a5a93b05.jpg";